import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./sass/variables.scss";
import VueGAPI from "vue-gapi";
// import * as d3 from "d3";

// create the 'options' object
const apiConfig = {
  apiKey: "AIzaSyD-fiWsvgBWTSdH-wxZE4Z5QUIRccRBLVM",
  clientId:
    "423358081402-3imodj46hdkf3sv1vog77sme3pr000v8.apps.googleusercontent.com",
  discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
  scope: "https://www.googleapis.com/auth/spreadsheets",
};

Vue.config.productionTip = false;
// Use the plugin and pass along the configuration
Vue.use(VueGAPI, apiConfig);

new Vue({
  router,
  store,
  vuetify,
  VueGAPI,
  render: (h) => h(App),
}).$mount("#app");
